"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2019 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/

/**
 * Image or file preview, displayed at the top of a card. Pass contents as children, often an Asset component.
 */
var CardPreview =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(CardPreview, _React$Component);

  function CardPreview() {
    (0, _classCallCheck2["default"])(this, CardPreview);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(CardPreview).apply(this, arguments));
  }

  (0, _createClass2["default"])(CardPreview, [{
    key: "render",
    value: function render() {
      var child = _react["default"].Children.only(this.props.children);

      var _this$context = this.context,
          cardVariant = _this$context.cardVariant,
          onLoad = _this$context.onLoad,
          hasTitle = _this$context.hasTitle;
      var smartness = 0;

      if (cardVariant === 'quiet') {
        smartness = 1;
      } // Default image to decorative if there is already a title in the CardBody.
      // If the child already defines the decorative prop or alt prop, don't override it.


      var decorative = hasTitle;

      if (child.props.decorative != null || child.props.alt != null) {
        decorative = child.props.decorative;
      }

      return _react["default"].createElement("div", {
        className: "spectrum-Card-preview"
      }, _react["default"].cloneElement(child, {
        smartness: smartness,
        onLoad: onLoad,
        decorative: decorative
      }));
    }
  }]);
  return CardPreview;
}(_react["default"].Component);

exports["default"] = CardPreview;
(0, _defineProperty2["default"])(CardPreview, "contextTypes", {
  cardVariant: _propTypes["default"].string,
  onLoad: _propTypes["default"].func,
  hasTitle: _propTypes["default"].bool
});